// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Uuid = require("uuid");
var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Context = require("../provider/Context.bs.js");
var User_Api = require("./User_Api.bs.js");
var Type_Club = require("../club/Type_Club.bs.js");
var User_Type = require("./User_Type.bs.js");
var Util_I18n = require("../util/Util_I18n.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Common = require("../type/Type_Common.bs.js");
var Type_String = require("../type/Type_String.bs.js");
var User_Context = require("./User_Context.bs.js");
var Belt_MutableMapString = require("@rescript/std/lib/js/belt_MutableMapString.js");
var Shim = require("use-sync-external-store/shim");

function make(base) {
  var t_encode = function (param) {
    return "";
  };
  var t_decode = function (param) {
    return {
            TAG: /* Ok */0,
            _0: Belt_MutableMapString.make(undefined)
          };
  };
  var Handlers = Type_String.$$Map.MakeMutable({
        Str: Type_String.Teaser.DsId,
        t_encode: t_encode,
        t_decode: t_decode
      });
  var handlers = Curry._1(Handlers.make, undefined);
  var getHandlers = function (param) {
    return Curry._3(Handlers.reduce, handlers, [], (function (acc, dsId, stringMap) {
                  return Belt_MutableMapString.reduce(stringMap, acc, (function (acc, listenerId, callback) {
                                var return_0 = [
                                  listenerId,
                                  dsId
                                ];
                                var $$return = [
                                  return_0,
                                  callback
                                ];
                                acc.push($$return);
                                return acc;
                              }));
                }));
  };
  var subscribe = function (dsId, callback) {
    var listenerId = Uuid.v4();
    var currentCallbacks = Belt_Option.getWithDefault(Curry._2(Handlers.get, handlers, dsId), Belt_MutableMapString.make(undefined));
    Belt_MutableMapString.set(currentCallbacks, listenerId, callback);
    Curry._3(Handlers.set, handlers, dsId, currentCallbacks);
    return [
            listenerId,
            dsId
          ];
  };
  var unsubscribe = function (param) {
    var dsId = param[1];
    var listenerId = param[0];
    Belt_Option.forEach(Curry._2(Handlers.get, handlers, dsId), (function (__x) {
            Belt_MutableMapString.remove(__x, listenerId);
          }));
    var match = Belt_Option.map(Curry._2(Handlers.get, handlers, dsId), Belt_MutableMapString.isEmpty);
    if (match !== undefined && match) {
      return Curry._2(Handlers.remove, handlers, dsId);
    }
    
  };
  var notify = function (dsId, progression) {
    var callbacks = Curry._2(Handlers.get, handlers, dsId);
    if (callbacks !== undefined) {
      return Belt_MutableMapString.forEach(Caml_option.valFromOption(callbacks), (function (_key, callback) {
                    Curry._1(callback, progression);
                  }));
    }
    
  };
  var getSnapshot = function (dsId, param) {
    return Belt_Option.getWithDefault(Curry._2(base.getInitialValue, undefined, dsId), base.defaultValue);
  };
  var use = function (dsId) {
    return Shim.useSyncExternalStore((function (param) {
                  var subscribeId = subscribe(dsId, (function (param) {
                          
                        }));
                  return function () {
                    return unsubscribe(subscribeId);
                  };
                }), (function (param) {
                  return getSnapshot(dsId, param);
                }), (function (param) {
                  return getSnapshot(dsId, param);
                }));
  };
  return {
          getHandlers: getHandlers,
          subscribe: subscribe,
          unsubscribe: unsubscribe,
          notify: notify,
          Hook: {
            use: use
          }
        };
}

var WithDsId = {
  make: make
};

function make$1(base) {
  var handlers = Belt_MutableMapString.make(undefined);
  var getHandlers = function (param) {
    return Belt_MutableMapString.reduce(handlers, [], (function (acc, key, callback) {
                  var $$return = [
                    key,
                    callback
                  ];
                  acc.push($$return);
                  return acc;
                }));
  };
  var subscribe = function (callback) {
    var listenerId = Uuid.v4();
    Belt_MutableMapString.set(handlers, listenerId, callback);
    return listenerId;
  };
  var unsubscribe = function (listenerId) {
    Belt_MutableMapString.remove(handlers, listenerId);
  };
  var notify = function (value) {
    Belt_MutableMapString.forEach(handlers, (function (_key, callback) {
            Curry._1(callback, value);
          }));
  };
  var getSnapshot = function (param) {
    return Belt_Option.getWithDefault(Curry._2(base.getInitialValue, undefined, undefined), base.defaultValue);
  };
  var subscribe$1 = function (callback) {
    var subscribeId = subscribe(function (param) {
          Curry._1(callback, undefined);
        });
    return function () {
      return Belt_MutableMapString.remove(handlers, subscribeId);
    };
  };
  var use = function (param) {
    return Shim.useSyncExternalStore(subscribe$1, getSnapshot, getSnapshot);
  };
  return {
          getHandlers: getHandlers,
          subscribe: subscribe,
          unsubscribe: unsubscribe,
          notify: notify,
          Hook: {
            use: use
          }
        };
}

var WithStringMap = {
  make: make$1
};

var defaultValue = Type_Common.Progression.noProgression;

function getInitialValue(getUserOpt, dsId) {
  var getUser = getUserOpt !== undefined ? getUserOpt : User_Context.getUser;
  return User_Type.getProgressionById(Curry._1(getUser, undefined), dsId);
}

var Base = {
  defaultValue: defaultValue,
  getInitialValue: getInitialValue
};

var include = make(Base);

var Progression_getHandlers = include.getHandlers;

var Progression_subscribe = include.subscribe;

var Progression_unsubscribe = include.unsubscribe;

var Progression_notify = include.notify;

var Progression_Hook = include.Hook;

var Progression = {
  Base: Base,
  getHandlers: Progression_getHandlers,
  subscribe: Progression_subscribe,
  unsubscribe: Progression_unsubscribe,
  notify: Progression_notify,
  Hook: Progression_Hook
};

function getInitialValue$1($staropt$star, param) {
  $staropt$star !== undefined;
}

var Base$1 = {
  defaultValue: /* Init */0,
  getInitialValue: getInitialValue$1
};

var Observable = make$1(Base$1);

function getInitialValue$2(getUserOpt, dsId) {
  var getUser = getUserOpt !== undefined ? getUserOpt : User_Context.getUser;
  return User_Type.getVideoById(dsId, Curry._1(getUser, undefined));
}

var Base$2 = {
  defaultValue: /* NotFavorite */1,
  getInitialValue: getInitialValue$2
};

var Observable$1 = make(Base$2);

var notify = Observable$1.notify;

var FavoriteStatus = {
  Base: Base$2,
  Observable: Observable$1,
  notify: notify
};

async function addFavorite(getUserOpt, setUserOpt, addFavoriteOpt, minutesLabel, locale, dsId) {
  var getUser = getUserOpt !== undefined ? getUserOpt : User_Context.getUser;
  var setUser = setUserOpt !== undefined ? setUserOpt : User_Context.setUser;
  var addFavorite$1 = addFavoriteOpt !== undefined ? addFavoriteOpt : User_Api.Favorites.add;
  var clubTeaser = await Curry._4(addFavorite$1, User_Context.getEnv(undefined), User_Type.getToken(Curry._1(getUser, undefined)), locale, dsId);
  if (clubTeaser.TAG !== /* Ok */0) {
    return ;
  }
  var clubTeaser$1 = clubTeaser._0;
  if (clubTeaser$1 === undefined) {
    return ;
  }
  var teaser = Type_Club.Teaser.toDsTeaser(minutesLabel, clubTeaser$1);
  var newUser = User_Type.addFavorite(Type_Club.Teaser.toDsTeaser(minutesLabel, clubTeaser$1), User_Context.getUser(undefined));
  Curry._1(setUser, newUser);
  Curry._1(Observable.notify, {
        TAG: /* Add */0,
        _0: teaser
      });
  return Curry._2(notify, dsId, /* Favorite */0);
}

async function removeFavorite(getUserOpt, setUserOpt, removeFavoriteOpt, teaserId) {
  var getUser = getUserOpt !== undefined ? getUserOpt : User_Context.getUser;
  var setUser = setUserOpt !== undefined ? setUserOpt : User_Context.setUser;
  var removeFavorite$1 = removeFavoriteOpt !== undefined ? removeFavoriteOpt : User_Api.Favorites.$$delete;
  var user = Curry._1(getUser, undefined);
  Curry._2(notify, teaserId, /* NotFavorite */1);
  var newUser = User_Type.removeFavorite(teaserId, user);
  Curry._1(setUser, newUser);
  await Curry._3(removeFavorite$1, User_Context.getEnv(undefined), User_Type.getToken(Curry._1(getUser, undefined)), teaserId);
  return Curry._1(Observable.notify, {
              TAG: /* Remove */1,
              _0: teaserId
            });
}

function useStatus(dsId) {
  var match = Context.I18n.getState(undefined);
  var locale = match.locale;
  var minutesLabel = match.labels.teaser.durationUnit;
  var locale$1 = React.useMemo((function () {
          return Util_I18n.localeToLanguage(locale);
        }), [locale]);
  var favoriteStatus = Curry._1(Observable$1.Hook.use, dsId);
  var add = React.useCallback((function (param) {
          addFavorite(undefined, undefined, undefined, minutesLabel, locale$1, dsId);
        }), [
        dsId,
        locale$1,
        minutesLabel
      ]);
  var remove = React.useCallback((function (param) {
          removeFavorite(undefined, undefined, undefined, dsId);
        }), [dsId]);
  return React.useMemo((function () {
                return {
                        status: favoriteStatus,
                        add: add,
                        remove: remove
                      };
              }), [
              favoriteStatus,
              add,
              remove
            ]);
}

var Hook = {
  useStatus: useStatus
};

var Favorite = {
  Base: Base$1,
  Observable: Observable,
  FavoriteStatus: FavoriteStatus,
  addFavorite: addFavorite,
  removeFavorite: removeFavorite,
  Hook: Hook
};

function getInitialValue$3(getUserOpt, dsId) {
  var getUser = getUserOpt !== undefined ? getUserOpt : User_Context.getUser;
  return User_Type.hasMagazine(dsId, Curry._1(getUser, undefined));
}

var Base$3 = {
  defaultValue: false,
  getInitialValue: getInitialValue$3
};

var Observable$2 = make(Base$3);

function subscribeToMagazine(getUserOpt, setUserOpt, dsId) {
  var getUser = getUserOpt !== undefined ? getUserOpt : User_Context.getUser;
  var setUser = setUserOpt !== undefined ? setUserOpt : User_Context.setUser;
  var match = User_Type.getToken(Curry._1(getUser, undefined));
  if (match === undefined) {
    return ;
  }
  if (typeof match === "number") {
    return ;
  }
  if (match.TAG === /* Anonymous */0) {
    return ;
  }
  var newUser = User_Type.addMagazine(dsId, User_Context.getUser(undefined));
  Curry._1(setUser, newUser);
  User_Api.Magazines.subscribe(User_Context.getEnv(undefined), match._0, dsId);
  Curry._2(Observable$2.notify, dsId, true);
}

function unSubscribeFromMagazine(getUserOpt, setUserOpt, dsId) {
  var getUser = getUserOpt !== undefined ? getUserOpt : User_Context.getUser;
  var setUser = setUserOpt !== undefined ? setUserOpt : User_Context.setUser;
  var match = User_Type.getToken(Curry._1(getUser, undefined));
  if (match === undefined) {
    return ;
  }
  if (typeof match === "number") {
    return ;
  }
  if (match.TAG === /* Anonymous */0) {
    return ;
  }
  Curry._1(setUser, User_Type.removeMagazine(dsId, Curry._1(getUser, undefined)));
  User_Api.Magazines.unSubscribe(User_Context.getEnv(undefined), match._0, dsId);
  Curry._2(Observable$2.notify, dsId, false);
}

function use(dsId) {
  var match = Context.I18n.getState(undefined);
  var locale = match.locale;
  var locale$1 = React.useMemo((function () {
          return Util_I18n.localeToLanguage(locale);
        }), [locale]);
  var magazineStatus = Curry._1(Observable$2.Hook.use, dsId);
  var add = React.useCallback((function (param) {
          subscribeToMagazine(undefined, undefined, dsId);
        }), [
        dsId,
        locale$1,
        match.labels.teaser.durationUnit
      ]);
  var remove = React.useCallback((function (param) {
          unSubscribeFromMagazine(undefined, undefined, dsId);
        }), [dsId]);
  return React.useMemo((function () {
                return {
                        status: magazineStatus,
                        add: add,
                        remove: remove
                      };
              }), [
              magazineStatus,
              add,
              remove
            ]);
}

var Hook$1 = {
  use: use
};

var Magazine = {
  Observable: Observable$2,
  subscribeToMagazine: subscribeToMagazine,
  unSubscribeFromMagazine: unSubscribeFromMagazine,
  Hook: Hook$1
};

var Magazine$1 = {
  Base: Base$3,
  Magazine: Magazine,
  Observable: Observable$2,
  subscribeToMagazine: subscribeToMagazine,
  unSubscribeFromMagazine: unSubscribeFromMagazine,
  Hook: Hook$1
};

var defaultValue$1 = User_Type.getToken(User_Context.getUser(undefined));

function getInitialValue$4(getUserOpt, param) {
  var getUser = getUserOpt !== undefined ? getUserOpt : User_Context.getUser;
  return Caml_option.some(User_Type.getToken(Curry._1(getUser, undefined)));
}

var Base$4 = {
  defaultValue: defaultValue$1,
  getInitialValue: getInitialValue$4
};

var include$1 = make$1(Base$4);

var Token_getHandlers = include$1.getHandlers;

var Token_subscribe = include$1.subscribe;

var Token_unsubscribe = include$1.unsubscribe;

var Token_notify = include$1.notify;

var Token_Hook = include$1.Hook;

var Token = {
  Base: Base$4,
  getHandlers: Token_getHandlers,
  subscribe: Token_subscribe,
  unsubscribe: Token_unsubscribe,
  notify: Token_notify,
  Hook: Token_Hook
};

var defaultValue$2 = User_Type.getUserStatus(User_Context.getUser(undefined));

function getInitialValue$5(getUserOpt, param) {
  var getUser = getUserOpt !== undefined ? getUserOpt : User_Context.getUser;
  return User_Type.getUserStatus(Curry._1(getUser, undefined));
}

var Base$5 = {
  defaultValue: defaultValue$2,
  getInitialValue: getInitialValue$5
};

var include$2 = make$1(Base$5);

var UserStatus_getHandlers = include$2.getHandlers;

var UserStatus_subscribe = include$2.subscribe;

var UserStatus_unsubscribe = include$2.unsubscribe;

var UserStatus_notify = include$2.notify;

var UserStatus_Hook = include$2.Hook;

var UserStatus = {
  Base: Base$5,
  getHandlers: UserStatus_getHandlers,
  subscribe: UserStatus_subscribe,
  unsubscribe: UserStatus_unsubscribe,
  notify: UserStatus_notify,
  Hook: UserStatus_Hook
};

var defaultValue$3 = User_Context.getStatus(undefined);

function getInitialValue$6(_getUserOpt, param) {
  return User_Context.getStatus(undefined);
}

var Base$6 = {
  defaultValue: defaultValue$3,
  getInitialValue: getInitialValue$6
};

var include$3 = make$1(Base$6);

var notify$1 = include$3.notify;

var Status_getHandlers = include$3.getHandlers;

var Status_subscribe = include$3.subscribe;

var Status_unsubscribe = include$3.unsubscribe;

var Status_Hook = include$3.Hook;

var Status = {
  Base: Base$6,
  getHandlers: Status_getHandlers,
  subscribe: Status_subscribe,
  unsubscribe: Status_unsubscribe,
  notify: notify$1,
  Hook: Status_Hook
};

var defaultValue$4 = User_Type.getAnonymousFeatureStatus(User_Context.getUser(undefined));

function getInitialValue$7(getUserOpt, param) {
  var getUser = getUserOpt !== undefined ? getUserOpt : User_Context.getUser;
  return User_Type.getAnonymousFeatureStatus(Curry._1(getUser, undefined));
}

var Base$7 = {
  defaultValue: defaultValue$4,
  getInitialValue: getInitialValue$7
};

function setAnonymousFeatureStatus(getUserOpt, setUserOpt, enabled) {
  var getUser = getUserOpt !== undefined ? getUserOpt : User_Context.getUser;
  var setUser = setUserOpt !== undefined ? setUserOpt : User_Context.setUser;
  var ensuredAnonymousFeatureStatus = enabled ? /* Enabled */0 : /* Disabled */1;
  var newUser = User_Type.updateAnonymousFeatureStatus(Curry._1(getUser, undefined), ensuredAnonymousFeatureStatus);
  Curry._1(setUser, newUser);
  User_Context.setStatus(/* NotInitialized */1);
  Curry._1(notify$1, /* NotInitialized */1);
}

function use$1(param) {
  var setAnonymous = React.useCallback(function (enabled) {
        setAnonymousFeatureStatus(undefined, undefined, enabled);
      });
  return React.useMemo((function () {
                return {
                        setAnonymous: setAnonymous
                      };
              }), [setAnonymous]);
}

var Hook$2 = {
  use: use$1
};

var AnonymousFeatureStatus = {
  setAnonymousFeatureStatus: setAnonymousFeatureStatus,
  Hook: Hook$2
};

var include$4 = make$1(Base$7);

var AnonymousFeatureStatus_getHandlers = include$4.getHandlers;

var AnonymousFeatureStatus_subscribe = include$4.subscribe;

var AnonymousFeatureStatus_unsubscribe = include$4.unsubscribe;

var AnonymousFeatureStatus_notify = include$4.notify;

var AnonymousFeatureStatus_Hook = include$4.Hook;

var AnonymousFeatureStatus$1 = {
  Base: Base$7,
  AnonymousFeatureStatus: AnonymousFeatureStatus,
  getHandlers: AnonymousFeatureStatus_getHandlers,
  subscribe: AnonymousFeatureStatus_subscribe,
  unsubscribe: AnonymousFeatureStatus_unsubscribe,
  notify: AnonymousFeatureStatus_notify,
  Hook: AnonymousFeatureStatus_Hook
};

exports.WithDsId = WithDsId;
exports.WithStringMap = WithStringMap;
exports.Progression = Progression;
exports.Favorite = Favorite;
exports.Magazine = Magazine$1;
exports.Token = Token;
exports.UserStatus = UserStatus;
exports.Status = Status;
exports.AnonymousFeatureStatus = AnonymousFeatureStatus$1;
/* include Not a pure module */
